<template>
  <div>
    <SidebarTitle v-if="!alwaysOpen" :plus="localValueEmpty && !pickerVisible" class="text-center mb-2" title="color tag" icon="TagIcon" @plusClicked="pickerVisible = true"/>
    <div v-if="pickerVisible || alwaysOpen" class="flex justify-center">
       <div>
        <div>
          <span class="radio-000000" @click.stop="$emit('colorChanged', '#000000')">
          <vs-radio :vs-name="generateName('000000')" color="#000000" class="transform hover:scale-125 mx-2" v-model="localValue" vs-value="#000000" > </vs-radio>
          </span>

        <span class="radio-3D3270" @click.stop="$emit('colorChanged', '#3D3270')">
          <vs-radio :vs-name="generateName('3D3270')" color="#3D3270" class="transform hover:scale-125 mx-2" v-model="localValue" vs-value="#3D3270"></vs-radio>
        </span>

        <span class="radio-424CE2" @click.stop="$emit('colorChanged', '#424CE2')">
          <vs-radio :vs-name="generateName('424CE2')" color="#424CE2" class="transform hover:scale-125 transform mx-2" v-model="localValue" vs-value="#424CE2"></vs-radio>
        </span>

        <span class="radio-2196F3" @click.stop="$emit('colorChanged', '#2196F3')">
          <vs-radio :vs-name="generateName('2196F3')" color="#2196F3" class="transform hover:scale-125 transform mx-2" v-model="localValue" vs-value="#2196F3"></vs-radio>
        </span>


        <span class="radio-9C28B1" @click.stop="$emit('colorChanged', '#9C28B1')">
          <vs-radio :vs-name="generateName('9C28B1')" color="#9C28B1" class="transform hover:scale-125 transform mx-2" v-model="localValue" vs-value="#9C28B1"></vs-radio>
        </span>
        </div>


        <div class="flex items-center mt-1">
          <span class="radio-E91D62" @click.stop="$emit('colorChanged', '#E91D62')">
            <vs-radio :vs-name="generateName('E91D62')" color="#E91D62" class="transform hover:scale-125 transform mx-2" v-model="localValue" vs-value="#E91D62"></vs-radio>
          </span>


          <span class="radio-F34336" @click.stop="$emit('colorChanged', '#F34336')">
            <vs-radio :vs-name="generateName('F34336')" color="#F34336" class="transform hover:scale-125 transform mx-2" v-model="localValue" vs-value="#F34336"></vs-radio>
          </span>

          <span class="radio-FFB800" @click.stop="$emit('colorChanged', '#FFB800')">
            <vs-radio :vs-name="generateName('FFB800')" color="#FFB800" class="transform hover:scale-125 transform mx-2" v-model="localValue" vs-value="#FFB800"></vs-radio>
          </span>


          <span class="radio-21C228" @click.stop="$emit('colorChanged', '#21C228')">
            <vs-radio :vs-name="generateName('21C228')" color="#21C228" class="transform hover:scale-125 transform mx-2" v-model="localValue" vs-value="#21C228"></vs-radio>
          </span>

          <span style="position: relative; left: -1px;">
            <feather-icon v-if="localValue" :class="actionElementCss" svgClasses="h-6 w-6" icon="XCircleIcon" class="pr-3 pl-2 cursor-pointer text-dark" @click.stop="localValue=''" />
             <feather-icon v-else icon="XCircleIcon" svgClasses="h-6 w-6" class="pr-3 pl-2 cursor-not-allowed opacity-25" @click.stop="localValue=''" />
          </span>
         </div>
       </div>
    </div>

    <div v-else-if="localValue" class="flex justify-center text-dark items-center" :class="actionElementCss" @click="pickerVisible = true">

      <vs-radio :color="localValue"  />

      <feather-icon  icon="EditIcon" class="ml-1 w-4 cursor-pointer"  />
    </div>
  </div>
</template>
<script>

import _ from 'lodash'
export default {
  components: {
  },
  props: ['value', 'namespace', 'alwaysOpen'],
  data () {
    return {
      localValue: null,
      pickerVisible: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.localValue = value
      }
    },
    localValue: {
      immediate: false,
      handler (localValue) {
        this.$emit('input', localValue)
        this.$emit('colorChanged', localValue)
      }
    }
  },
  computed: {
    localValueEmpty () {
      return _.isEmpty(this.localValue)
    }
  },
  methods: {
    generateName (color) {
      return `${color}-${this.namespace}`
    }

  }
}
</script>


<style>
.radio-000000 .vs-radio--borde {
  border-color: #000000 !important
}

.radio-3D3270 .vs-radio--borde {
  border-color: #3D3270 !important
}

.radio-424CE2 .vs-radio--borde {
  border-color: #424CE2 !important
}

.radio-FC9905 .vs-radio--borde {
  border-color: #FC9905 !important
}

.radio-2196F3 .vs-radio--borde {
  border-color: #2196F3 !important
}

.radio-9C28B1 .vs-radio--borde {
  border-color: #9C28B1 !important
}

.radio-E91D62 .vs-radio--borde {
  border-color: #E91D62 !important
}

.radio-F34336 .vs-radio--borde {
  border-color: #F34336 !important
}

.radio-FFB800 .vs-radio--borde {
  border-color: #FFB800 !important
}

.radio-21C228 .vs-radio--borde {
  border-color: #21C228 !important
}
</style>
